import React, {useCallback, useEffect, useMemo} from "react";
import {connect} from "react-redux";
import {hashHistory} from "react-router";

import PS from "../../ProjectScope/ProjectScopeActionsNew";
import PricingContext, {usePricingContext} from "../PricingContext";
import ROUTES from "../../../routes";
import AddButton from "../PricingComponents/AddButton";
import {clearInitialValues} from "../../AddNewEntity/AddNewEntityActions";
import {clearFeaturesSetup} from "../../FeaturesSetup/featuresActions";
import {setPricingGroupName, showPricingPopup} from "../pricingActions";
import PRICING_POPUP_TYPES from "../PricingPopups/pricingPopupTypes";
import PricingCatalogs from "./PricingCatalogs";


const PricingSidebar = (props) => {

  const {featureGroupsLoading, loadFeaturesGroups, featureGroups, pricingSearchText, clearInitialValues,
    clearFeaturesSetup, showPricingPopup, pricingCustomGroupNames, pricingFeatureGroupsChecked, setPricingGroupName,
  } = props;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName} = routeParams;
  console.log("routeParams", routeParams);

  useEffect(() => {
    loadFeaturesGroups(false);
    return () => {
      clearInitialValues();
      clearFeaturesSetup()
    }
  }, []);

  useEffect(() => {
    setPricingGroupName(paramsGroupName);
  }, [paramsGroupName]);

  const sidebarFeatureGroupClick = useCallback((featureGroup) => {
    return hashHistory.push(ROUTES.pricing + "/" + featureGroup.groupName);
  }, [hashHistory]);

  const displayFeatureGroups = useMemo(() => {
    if (featureGroupsLoading) {
      return []
    }
    let displayGroups = featureGroups.filter(featureGroup => {
      return pricingFeatureGroupsChecked.includes(featureGroup.groupName || "")
    });
    if (pricingSearchText) {
      const lowerCasedText = pricingSearchText.toLowerCase();
      displayGroups = displayGroups.filter(featureGroup => {
        return (featureGroup.customDisplayName || featureGroup.groupName || "").toLowerCase().includes(lowerCasedText)
      })
    }
    return displayGroups
  }, [featureGroupsLoading, pricingSearchText, featureGroups, pricingFeatureGroupsChecked]);

  return (
    <aside className="pr-aside scrollbar3 flex">
      <div className="flex-1 pr-aside__cell flex flex--column height-100 border-box">
        <div className="flex flex--center pb-0-25">
          <AddButton text="Enable Groups" onClick={() => showPricingPopup(true, PRICING_POPUP_TYPES.featureGroups)}/>
        </div>
        <div className="flex-item">
          {featureGroupsLoading
            ? <div className="ui-loader ui-loader--medium" style={{height: "98px"}}/>
            : displayFeatureGroups.map(featureGroup => {
              return (
                <div className={"pt-1 pb-1 pl-05 pr-05 flex flex--center nowrap link pr-aside__cell-item text-center"
                  + (paramsGroupName === featureGroup.groupName ? " bg-darkgreen2 color-light" : " bg-mochagrunge")}
                     onClick={() => sidebarFeatureGroupClick(featureGroup)}
                     key={featureGroup.id || featureGroup.groupName}>
                  <span className="font--14 bold width-100">
                    {pricingCustomGroupNames[featureGroup.groupName] || featureGroup.customDisplayName || featureGroup.groupName}
                  </span>
                </div>
              )
            })}
        </div>
      </div>
      <PricingCatalogs/>
    </aside>
  )
};

const mapStateToProps = (store) => {
  const {loading, featuresGroups} = store.projectScopeNew;
  const {pricingSearchText, pricingCustomGroupNames, pricingFeatureGroupsChecked} = store.pricingState;

  return {
    featureGroupsLoading: loading,
    featureGroups: featuresGroups,
    pricingSearchText,
    pricingCustomGroupNames,
    pricingFeatureGroupsChecked,
  };
};

const mapDispatchToProps = {
  loadFeaturesGroups: PS.loadFeaturesGroups,
  clearInitialValues,
  clearFeaturesSetup,
  showPricingPopup,
  setPricingGroupName,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingSidebar);
